import { CustomFieldDto } from 'types/customFields';
import { PracticeArea, PracticeAreaCreateDto, PracticeAreaForm, PracticeAreaType } from 'types/practice-areas';

/**
 * The edit form's values for a stored practice area; the form adds the custom fields' values itself. Without one
 * (it failed to load) the edit page shows the blank form.
 */
export const practiceAreaDtoToForm = (practiceArea: PracticeArea | undefined): PracticeAreaForm => ({
    name: practiceArea?.name ?? '',
    isActive: practiceArea?.isActive ?? true,
    practiceAreaType: practiceArea?.practiceAreaTypeCode ?? PracticeAreaType.PRACTICE_AREA,
    parent: practiceArea?.parentPracticeArea ?? null,
    practiceGroup: practiceArea?.practiceGroup ?? null,
    practiceTeams: practiceArea?.practiceTeams ?? [],
    isAmlApplicable: practiceArea?.isAmlApplicable ?? false,
    isExcludedFromAutomaticClosing: practiceArea?.isExcludedFromAutomaticClosing ?? false,
    applyExclusionToSubareas: false,
    showInTimecards: practiceArea?.showInTimecards ?? true,
    showInCases: practiceArea?.showInCases ?? true,
    showInEmployees: practiceArea?.showInEmployees ?? true,
});

export const practiceAreaFormToRequest = (
    form: PracticeAreaForm,
    customFields: CustomFieldDto[]
): PracticeAreaCreateDto => ({
    name: form.name,
    isActive: form.isActive,
    practiceAreaTypeCode: form.practiceAreaType,
    parentId: form.practiceAreaType !== PracticeAreaType.PRACTICE_AREA && form.parent?.id ? form.parent.id : null,
    isAmlApplicable: form.isAmlApplicable,
    isExcludedFromAutomaticClosing: form.isExcludedFromAutomaticClosing,
    applyExclusionToSubareas: form.isExcludedFromAutomaticClosing && form.applyExclusionToSubareas,
    showInTimecards: form.showInTimecards,
    showInCases: form.showInCases,
    showInEmployees: form.showInEmployees,
    practiceGroup: form.practiceGroup,
    customFields: customFields.length > 0 ? customFields : undefined,
});

/** The form fields each card of the practice area page edits; the teams follow the group and are not sent. */
export const PRACTICE_AREA_SECTION_FIELDS = {
    'practice-area': [
        'practiceAreaType',
        'name',
        'parent',
        'practiceGroup',
        'practiceTeams',
        'isAmlApplicable',
        'isExcludedFromAutomaticClosing',
        'applyExclusionToSubareas',
        'isActive',
    ],
    visibility: ['showInTimecards', 'showInCases', 'showInEmployees'],
    'custom-fields': [],
} satisfies Record<string, (keyof PracticeAreaForm)[]>;

export type PracticeAreaSectionId = keyof typeof PRACTICE_AREA_SECTION_FIELDS;
